import { messagesTypes } from '../constants/messagesConstants';

const initialState = {
    messages: {},
    unread: {},
};

export const messagesReducer = (state = initialState, action) => {
    switch (action.type) {
        case messagesTypes.SEND_MESSAGE:
            return {
                ...state,
                unread: {
                    ...state.unread,
                    [action.to]: {
                        name: action.userName,
                        email: action.userEmail,
                        unread: 0,
                        lastSeen: (new Date()).getTime(),
                    },
                },
                messages: {
                    ...state.messages, 
                    [action.to]:[
                        ...(state.messages[action.to] ?? []),
                        {
                            id: null,
                            from: action.from,
                            to: action.to,
                            date: (new Date()).getTime(),
                            message: action.message,
                        }
                    ]
                }
            };

        case messagesTypes.RECEIVE_MESSAGE:
            return {
                ...state,
                unread: {
                    ...state.unread,
                    [action.from]: (state.unread[action.from] ? {
                        name: action.userName,
                        email: action.userEmail,
                        unread: state.unread[action.from].unread + 1,
                        lastSeen: (new Date()).getTime(),
                    } : {
                        unread: 0,
                        lastSeen: (new Date()).getTime(),
                    }),
                },
                messages: {
                    ...state.messages, 
                    [action.from]:[
                        ...(state.messages[action.from] ?? []),
                        {
                            id: null,
                            from: action.from,
                            to: action.to,
                            date: (new Date()).getTime(),
                            message: action.message,
                        }
                    ]
                }
            };

        case messagesTypes.UPDATE_MESSAGE:

            let result = {};
            for(let from in state.messages) {
                result[from] = [];
                for (let m in state.messages[from]) {
                    let msg = state.messages[from][m];
                    if (action.id === msg.id) {
                        msg.message = action.message
                    }
                    result[from].push(msg);
                }
            }
            return {
                ...state,
                messages: result
            };
    
        case messagesTypes.LOAD_MESSAGES:
            return {
                ...state,
                unread: {
                    ...state.unread,
                    [action.from]: {
                        ...(state.unread[action.from] ?? {}),
                        unread: 0,
                        lastSeen: state.unread[action.from] ? state.unread[action.from].lastSeen : 0,
                    },
                },
                messages: {
                    ...state.messages, 
                    [action.from]: action.messages
                }
            };
    
        case messagesTypes.LOAD_FRIENDS:
            return {
                ...state,
                unread: action.friends
            };
    
        case messagesTypes.CLEAR_UNREAD_MESSAGES:
            return {
                ...state,
                unread: {
                    ...state.unread, 
                    [action.from]: {
                        ...(state.unread[action.from] ?? {}),
                        unread: 0,
                        lastSeen: (new Date()).getTime(),
                    }
                }
            };
    

        default:
            return state;
    }
};